

import {
  SessionManager,
  LoggerUtility
} from '../components/ComponentsLibrary';

class TimerUtility {
  constructor(updateCallback) {
    try {
      this.timer = null;
      this.seconds = 0;
      this.updateCallback = updateCallback; // Callback to update UI
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, "TimerUtility", "TimerUtility Constructor load");
    }
  }

  // Function to format time as MM:SS
  formatTime = (totalSeconds) => {
    try {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TimerUtility - formatTime", {});
    }
  };

  startTimer = () => {
    try {
      if (this.timer !== null) return; // Avoid multiple intervals

      this.timer = setInterval(() => {
        this.seconds += 1;
        this.updateCallback(this.formatTime(this.seconds)); // Send formatted time
      }, 1000);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TimerUtility - startTimer", {});
    }
  };

  resetTimer = () => {
    try {
      clearInterval(this.timer);
      this.timer = null;
      this.seconds = 0;
      this.updateCallback(this.formatTime(this.seconds)); // Reset to "00:00" 
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TimerUtility - resetTimer", {});
    }
  };
}

  export default TimerUtility;